import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export function ResourceSuspended() {
    const modalTitle = <Typography>Inhalt nicht mehr verfügbar!</Typography>;
    const modalContent = (
        <ContentTypography>
            Die Aktion kann nicht ausgeführt werden, da der Inhalt entfernt
            wurde.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
